var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",attrs:{"dark":"","color":"blue"}},[_vm._v(" Edit "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-pencil")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }